/* eslint-disable */
import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import {
  Grid,
  Select,
  FormControl,
  MenuItem,
  Button,
  Box,
  Typography,
  ListSubheader,
  InputAdornment,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { exploreListInfo, FilterInfo, FilterSelected, ListItem } from "../../types/types";
import { expandCardStyles } from "../../components/styles/customStyles";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FilterHandler,
  FiltersHandler,
  getComponent,
  getExploreUrl,
  normalizeType,
} from "../../assets/library";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Images from "../../assets/";
import { getFilterOptions } from "../../services";
import { filterFacets, filterOptions } from "../../assets/menu";
import { BeatLoader } from "react-spinners";

const FACET_CACHE_TTL_MS = 60 * 1000;
type FacetCacheEntry = { data: any; timestamp: number };
const FACET_LAST_TAB_CACHE_TTL_MS = 30 * 60 * 1000;
type FacetPerfSample = {
  ts: number;
  tab: string;
  source: "memory" | "queryLocal" | "network";
  durationMs: number;
  filtersCount: number;
  fallbackRendered: boolean;
  dedupedRequest?: boolean;
};

const TemporaryDrawer: React.FC<{
  open?: boolean;
  setOpen?: any;
  appliedFilters: FilterSelected[];
  setAppliedFilter: any;
  // options: FilterInfo[];
}> = ({ setAppliedFilter, appliedFilters, open, setOpen }) => {
  const navigate = useNavigate();
  const handleRemoveItem = (
    FilterItem: FilterSelected,
    removeItem: ListItem
  ) => {
    const encodedUrl = location.search.slice(1);
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = "";
    }

    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    let allFilters = FiltersHandler(
      {
        ...FilterItem,
        data: FilterItem?.data?.filter((data) => data?.name != removeItem?.name),
      },
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState<any>(null);
  const facetsCacheRef = useRef<Map<string, FacetCacheEntry>>(new Map());
  const inFlightRequestsRef = useRef<Map<string, Promise<any>>>(new Map());
  const latestRequestIdRef = useRef(0);
  const getNow = () => {
    try {
      return typeof performance !== "undefined" ? performance.now() : Date.now();
    } catch {
      return Date.now();
    }
  };

  const recordFacetPerf = (sample: FacetPerfSample) => {
    try {
      const key = "__facet_perf_metrics__";
      const raw = sessionStorage.getItem(key);
      const parsed = raw ? JSON.parse(raw) : [];
      const next = Array.isArray(parsed) ? parsed : [];
      next.push(sample);
      // Keep last 120 samples only.
      if (next.length > 120) next.splice(0, next.length - 120);
      sessionStorage.setItem(key, JSON.stringify(next));
    } catch {
      // Never block render path for telemetry.
    }
  };

  const location = useLocation();
  const listData = useRef<exploreListInfo>({
    type: "courses",
    page: 0,
    filterData: [],
    currency: "INR",
    search: "",
    totalItems: 0,
    totalPages: 1,
    appliedFilters: [],
  });
  const FilterData = useRef<FilterSelected[]>([]);
  const activeTab = useRef<string>("");

  const readDefaultLocalCache = (tab: string): FacetCacheEntry | null => {
    try {
      const raw = localStorage.getItem(`facetOptions_${tab}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.data && parsed?.timestamp) return parsed as FacetCacheEntry;
      // Backward compatibility for older cache format.
      if (parsed && typeof parsed === "object") {
        return { data: parsed, timestamp: Date.now() - (FACET_CACHE_TTL_MS + 1) };
      }
      return null;
    } catch {
      return null;
    }
  };

  const getPerQueryStorageKey = (cacheKey: string) => {
    try {
      return `facetOptions_query_${window.btoa(cacheKey)}`;
    } catch {
      return `facetOptions_query_${cacheKey}`;
    }
  };

  const readPerQueryLocalCache = (cacheKey: string): FacetCacheEntry | null => {
    try {
      const raw = localStorage.getItem(getPerQueryStorageKey(cacheKey));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.data && parsed?.timestamp) return parsed as FacetCacheEntry;
      return null;
    } catch {
      return null;
    }
  };

  const writePerQueryLocalCache = (cacheKey: string, data: any) => {
    try {
      localStorage.setItem(
        getPerQueryStorageKey(cacheKey),
        JSON.stringify({ data, timestamp: Date.now() } as FacetCacheEntry)
      );
    } catch {}
  };

  const readLastTabLocalCache = (tab: string): FacetCacheEntry | null => {
    try {
      const raw = localStorage.getItem(`facetOptions_last_${tab}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.data && parsed?.timestamp) return parsed as FacetCacheEntry;
      return null;
    } catch {
      return null;
    }
  };

  const writeLastTabLocalCache = (tab: string, data: any) => {
    try {
      localStorage.setItem(
        `facetOptions_last_${tab}`,
        JSON.stringify({ data, timestamp: Date.now() } as FacetCacheEntry)
      );
    } catch {}
  };

  const writeDefaultLocalCache = (tab: string, data: any) => {
    try {
      localStorage.setItem(
        `facetOptions_${tab}`,
        JSON.stringify({ data, timestamp: Date.now() } as FacetCacheEntry)
      );
    } catch {}
  };

  const fetchFacetOptionsDeduped = (cacheKey: string, payload: any) => {
    const existingRequest = inFlightRequestsRef.current.get(cacheKey);
    if (existingRequest) return existingRequest;

    const request = getFilterOptions(activeTab.current, payload)
      .finally(() => {
        inFlightRequestsRef.current.delete(cacheKey);
      });
    inFlightRequestsRef.current.set(cacheKey, request);
    return request;
  };

  const allOptions = async (values: any,project?:string[]) => {
    console.log("Filters",values);
    const requestStartedAt = getNow();
    try {
      const transformedFilters = values.map((filter: any) => ({
        type: filter.type,
        data: filter.data.map((item: any) => item.value),
      }));
      const cacheKey = JSON.stringify({
        tab: activeTab.current,
        filters: transformedFilters,
        project: project ?? [],
      });

      const isDefaultFacetRequest = transformedFilters.length === 0 && (project ?? []).length === 0;
      const memoryEntry = facetsCacheRef.current.get(cacheKey);
      const now = Date.now();
      const isMemoryFresh = !!memoryEntry && now - memoryEntry.timestamp < FACET_CACHE_TTL_MS;
      const queryLocalEntry = readPerQueryLocalCache(cacheKey);
      const isQueryLocalFresh = !!queryLocalEntry && now - queryLocalEntry.timestamp < FACET_CACHE_TTL_MS;
      let fallbackRendered = false;

      // Serve from in-memory cache immediately (SWR).
      if (memoryEntry?.data) {
        setOptions(memoryEntry.data);
        fallbackRendered = true;
      } else if (queryLocalEntry?.data) {
        // Serve exact query cache from localStorage immediately.
        setOptions(queryLocalEntry.data);
        facetsCacheRef.current.set(cacheKey, queryLocalEntry);
        fallbackRendered = true;
      } else if (isDefaultFacetRequest && !options) {
        // Warm-start first render from localStorage for default facet state.
        const localEntry = readDefaultLocalCache(activeTab.current);
        if (localEntry?.data) {
          setOptions(localEntry.data);
          facetsCacheRef.current.set(cacheKey, localEntry);
          fallbackRendered = true;
        }
      } else if (!options) {
        // Last fallback: show previous tab facets while exact query is loading.
        const lastTabEntry = readLastTabLocalCache(activeTab.current);
        if (
          lastTabEntry?.data &&
          now - lastTabEntry.timestamp < FACET_LAST_TAB_CACHE_TTL_MS
        ) {
          setOptions(lastTabEntry.data);
          fallbackRendered = true;
        }
      }

      // If cache is fresh, skip network and return instantly.
      if (isMemoryFresh || isQueryLocalFresh) {
        recordFacetPerf({
          ts: Date.now(),
          tab: activeTab.current,
          source: isMemoryFresh ? "memory" : "queryLocal",
          durationMs: Math.round(getNow() - requestStartedAt),
          filtersCount: transformedFilters.length,
          fallbackRendered,
        });
        setLoading(false);
        return;
      }

      // Show loader only if nothing is currently renderable.
      setLoading(!(memoryEntry?.data || options));
      const requestId = ++latestRequestIdRef.current;
      const dedupedRequest = inFlightRequestsRef.current.has(cacheKey);
      const response = await fetchFacetOptionsDeduped(cacheKey, {
        filterData: transformedFilters,
        project: project ?? [],
      });

      // Ignore stale responses when a newer request has already started.
      if (requestId !== latestRequestIdRef.current) return;

      if (response && response.data && response.data[0]) {
        const entry: FacetCacheEntry = { data: response.data[0], timestamp: Date.now() };
        setOptions(entry.data);
        facetsCacheRef.current.set(cacheKey, entry);
        writePerQueryLocalCache(cacheKey, entry.data);
        writeLastTabLocalCache(activeTab.current, entry.data);
        if (isDefaultFacetRequest) {
          writeDefaultLocalCache(activeTab.current, entry.data);
        }
        recordFacetPerf({
          ts: Date.now(),
          tab: activeTab.current,
          source: "network",
          durationMs: Math.round(getNow() - requestStartedAt),
          filtersCount: transformedFilters.length,
          fallbackRendered,
          dedupedRequest,
        });
      }
    } catch (error) {
      console.error("Error fetching filter options:", error);
    } finally {
      setLoading(false)
    }
  };
  
  useEffect(() => {
    const encodedUrl = location.search.slice(1);
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch {
      decodedUrl = "";
    }
    const queryParams = new URLSearchParams(decodedUrl);
    let filterUrl = queryParams.get("FilterData");
    let activeUrl = queryParams.get("activeTab");
    FilterData.current =
      filterUrl !== undefined && filterUrl !== null
        ? JSON.parse(filterUrl)
        : [];
    activeTab.current = activeUrl ? JSON.parse(activeUrl) : "courses";

    listData.current.appliedFilters = FilterData.current;
    listData.current.type = activeTab.current;
    allOptions(listData.current.appliedFilters,[])
  }, [location]);


  const transformBackendDataToFilterOptions = (
    data: Record<string, { _id: string | boolean; count: number }[]>
  ): FilterInfo[] => {
    return Object.entries(data)
      .filter(([key]) => key.toLowerCase() !== 'gpa') // Filter out GPA from API response
      .map(([key, values]) => {
      const config = filterFacets[key as keyof typeof filterFacets] || {
        label: key.charAt(0).toUpperCase() + key.slice(1),
        icon: "",
        selectedType: "multi",
        searchbox: false,
      };
  
      let options = values.map(item => {
        let name: string;
        if (typeof item._id === "boolean") {
          if (key === "featured") {
            name = item._id ? "Featured" : "Not Featured";
          } else if (key === "GRE") {
            name = item._id ? "GRE Acceptance" : "No GRE";
          } else if (key === "GMAT") {
            name = item._id ? "GMAT Acceptance" : "No GMAT";
          } else if (key === "IELTS") {
            name = item._id ? "IELTS Acceptance" : "No IELTS";
          } else if (key === "TOEFL") {
            name = item._id ? "TOEFL Acceptance" : "No TOEFL";
          } else if (key === "PTE") {
            name = item._id ? "PTE Acceptance" : "No PTE";
          } else if (key === "Duolingo") {
            name = item._id ? "Duolingo Acceptance" : "No Duolingo";
          } else {
            name = item._id ? `${config.label}` : `No ${config.label}`;
          }
        } else {
          name = String(item._id);
        }
  
        return {
          name,
          value: item._id,
          count: item.count,
        };
      });
  
      if (key === "featured") {
        options = options.sort((a, b) => {
          if (a.name.includes("Yes") && !b.name.includes("Yes")) {
            return -1;
          }
          if (!a.name.includes("Yes") && b.name.includes("Yes")) {
            return 1;
          }
          return 0;
        });
      }
  
      return {
        type: key,
        label: config.label,
        icon: config.icon,
        options,
        selectedType: config.selectedType,
        searchbox: config.searchbox,
      };
    });
  };
  const transformedOptions = useMemo(
    () => (options ? transformBackendDataToFilterOptions(options) : []),
    [options]
  );
  const activeTabState = activeTab.current === "universities" ? "universities" : "courses";
  const staticFallbackOptions = useMemo(() => {
    const baseOptions = (filterOptions as any)?.[activeTabState] || [];
    // Keep only light-weight, high-value filters for instant fallback shell.
    const priorityTypes = new Set(["country", "state", "city", "type", "discipline", "subDiscipline"]);
    return (baseOptions as FilterInfo[]).filter((item) => priorityTypes.has(item.type));
  }, [activeTabState]);
  const effectiveOptions = transformedOptions.length > 0 ? transformedOptions : staticFallbackOptions;
  
  

  return (
    <div>
      <Box
        sx={{
          height: "90%",
          "& .MuiSelect-select": {
            fontSize: "14px",
          },
        }}
      >
        <Grid container sx={{}}>
          <Grid item xs={12} sx={{ background: "#F5F5F5", p: 2, display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <img src={Images.filterIcon} alt="icon" style={{ width: "20px" }} />
            {appliedFilters?.length > 0 &&
              !appliedFilters.every((item) => item?.type === "name") ? (
              <Typography
                sx={{
                  color: "#495052",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontSize: "14px",
                  fontWeight: 500
                }}
                onClick={() => {
                  navigate(getExploreUrl("filterData", []));
                }}
              >
                Clear all
              </Typography>
            ) : null}
          </Grid>
          <Grid item xs={12} sx={{ 
            maxHeight: "120px", 
            overflowY: "auto", 
            overflowX: "hidden",
            color: "#495052",
            p: 1,
            // Hide scrollbar for all browsers
            '::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}>
            {appliedFilters?.map((item) =>
              item?.data?.map((text: any, i: any) => (
                <Button key={i} sx={expandCardStyles?.filteredList}>
                  {text?.name}
                  <CloseIcon
                    // className="close-icon"
                    sx={{
                      marginLeft: 1,
                      fontSize: "1rem",
                      color: "red"
                    }}
                    onClick={() => handleRemoveItem(item, text)}
                  />
                </Button>
              ))
            )}
          </Grid>
        </Grid>
        {!effectiveOptions.length && loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 2 }}>
            <BeatLoader color="#3b3f76"/> 
          </Box>
        ) :
          <Box
            sx={{
              height: "calc(100vh - 400px)",
              overflowY: "auto",
              overflowX: "hidden",
              // Hide scrollbar for all browsers
              '::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                p: 1,
              }}
            >
              {loading && effectiveOptions.length > 0 && (
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "12px", color: "#8E9091" }}>
                    Updating filters...
                  </Typography>
                </Grid>
              )}
              {effectiveOptions.map((item: FilterInfo) => (
                <Grid item xs={12} key={item.type}>
                  <div onClick={()=>console.log("Filter Clicked",item)}>
                    <FilterContainer
                      data={item}
                      appliedFilter={
                        appliedFilters?.find((item2) => item2.type == item.type)
                          ? appliedFilters.find((item2) => item2.type == item.type)
                          : { type: item.type, data: [] }
                      }
                      onSelection={FilterHandler}
                      normalizeType={normalizeType}
                      appliedFilters={appliedFilters}
                    />
                  </div>
                </Grid>
              ))}
              {/* <Budget 
              appliedFilter={
                      appliedFilters?.find((item2) => item2.type == "budget")
                        ? appliedFilters.find((item2) => item2.type == "budget")
                        : { type: "budget", data: [] }
                    }
                    onSelection={FilterHandler}
                    normalizeType={normalizeType}
                    appliedFilters={appliedFilters}/> */}
            </Grid>
          </Box>
        }

      </Box>
    </div>
  );
};

const FilterContainer = (props: {
  data: FilterInfo;
  initialValue?: FilterSelected | undefined;
  onSelection: any;
  normalizeType: any;
  appliedFilter: any;
  appliedFilters: FilterSelected[] | undefined;
}) => {
  // const CustomComponent:
  //   | React.FC<{
  //     data: any;
  //     initialValue: any;
  //     onSelection: any;
  //     appliedFilter: FilterSelected;
  //     appliedFilters: FilterSelected[] | undefined;
  //   }>
  //   | any =
  //   props.data.customContainer !== undefined && props.data.customContainer?.name
  //     ? getComponent(props.data.customContainer?.name)
  //     : null;

  return (
    <>
      {/* {CustomComponent ? (
        <CustomComponent
          appliedFilter={props.appliedFilter}
          data={props.data}
          initialValue={
            props.initialValue
              ? props.initialValue
              : { type: props.data.type, data: [] }
          }
          onSelection={props.onSelection}
          appliedFilters={props.appliedFilters}
        />
      ) : ( */}
      <DefaultContainer
        appliedFilter={props?.appliedFilter}
        data={props?.data}
        initialValue={
          props?.initialValue
            ? props?.initialValue
            : { type: props?.data?.type, data: [] }
        }
        onSelection={props?.onSelection}
        normalizeType={props?.normalizeType}
      />
      {/* )} */}
    </>
  );
};

const DefaultContainer = (props: {
  data: FilterInfo;
  initialValue: FilterSelected | undefined;
  onSelection: any;
  normalizeType: any;
  appliedFilter: FilterSelected;
}) => {
  const navigate = useNavigate();
  const onSelection = (val: ListItem) => {
    let filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });
    const encodedUrl = location.search.slice(1);
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = "";
    }

    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    let allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };

  const ITEM_HEIGHT = 78;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 220,
      },
    },
  };

  const [searchQuery, setSearchQuery] = useState("");
  const displayedOptions = useMemo(
    () =>
      props?.data?.options?.filter((option: any) =>
        option?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [searchQuery, props?.data?.options]
  );

  return (
    <>
      <FormControl fullWidth>
        <Select
          value=""
          onChange={(e: any) => onSelection(e?.target?.value)}
          onClose={() => setSearchQuery("")}
          renderValue={(selected: any) => {
            if (selected.length === 0) {
              return (
                <Typography
                  sx={{ textTransform: "capitalize", fontSize: "14px", display: "flex", alignItems: "center", gap: "0.5rem", fontWeight: "500" }}
                >
                  <img src={props.data.icon} alt="icon" style={{ width: "15px" }} />
                  {props.normalizeType(props.data.label)}
                </Typography>
              );
            }
            return selected.join(",");
          }}
          size="small"
          fullWidth
          displayEmpty
          sx={{
            "&.MuiInputBase-root": {
              borderRadius: "0px !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderBottom: "1px solid #00000033 !important",
              border: 0
            },
          }}
          defaultValue=""
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                maxWidth: 300,
                "&.MuiPaper-root": {
                  boxShadow: 3,
                  borderRadius: "15px !important",
                },
              },
            },
            autoFocus: false,
          }}
          IconComponent={ExpandMoreIcon}
        >
          {props.data?.searchbox ? (
            <ListSubheader>
              <TextField
                size="small"
                // Autofocus on textfield
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={(e: any) => setSearchQuery(e?.target?.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
          ) : null}
          {displayedOptions?.map((option: any, i: number) => (
            <MenuItem
              key={i}
              value={option}
              sx={{
                backgroundColor: props.appliedFilter?.data.find(
                  (data) => data?.value === option?.value
                ) ? "#e3f2fd" : "transparent",
                "&:hover": {
                  backgroundColor: props.appliedFilter?.data.find(
                    (data) => data?.value === option?.value
                  ) ? "#bbdefb" : "#f5f5f5",
                },
                "& .MuiSvgIcon-root ": {
                  fontSize: "0.9rem",
                  color: "#1976d2",
                },
                whiteSpace: "normal",
                borderRadius: "4px",
                margin: "2px 8px",
                padding: "8px 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Typography 
                  fontWeight={props.appliedFilter?.data.find(
                    (data) => data?.value === option?.value
                  ) ? "500" : "300"} 
                  fontSize="14px"
                  color={props.appliedFilter?.data.find(
                    (data) => data?.value === option?.value
                  ) ? "#1976d2" : "inherit"}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                > 
                  {option?.name}
                </Typography>
                {props.appliedFilter?.data.find(
                  (data) => data?.value === option?.value
                ) ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
                    <Typography sx={{ fontSize: "12px !important", color: "#1976d2", fontWeight: "500" }}>
                      {option?.count}
                    </Typography>
                    <CheckCircleIcon fontSize="small" sx={{ color: "#1976d2" }} />
                  </div>
                ) : (
                  <Typography sx={{ fontSize: "12px !important", color: "#666", flexShrink: 0 }}>
                    {option?.count}
                  </Typography>
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default TemporaryDrawer;
